import Alpine from 'alpinejs';
export function getAlpineStore(key) {
    return Alpine.store(key);
}
export function setAlpineStore(key, value) {
    Alpine.store(key, value);
}
